export const COOKIE_POLICY_KEY = 'cookieJSON';
export const FONT_SIZE_KEY = 'fontSize'